import { FaBars, FaTimes, FaArrowRight, FaInstagram, FaLinkedin, FaTwitter, FaEnvelope } from 'react-icons/fa';

export const Icon = {
    "BarMenu": FaBars,
    "CancelMenu": FaTimes,
    "Arrow": FaArrowRight,
    "Instagram": FaInstagram,
    "LinkedIn": FaLinkedin,
    "Twitter": FaTwitter,
    "Email": FaEnvelope
}